import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";

import {
    faAddressCard,
    faAlignJustify,
    faAlignLeft,
    faAngleRight,
    faBed,
    faCheck,
    faComment,
    faInfoCircle,
    faPaperclip,
    faPlus,
    faSearch,
    faTimes,
    faUser,
    faUserSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    ListarProdutosPorContaCompleto,
    VerificarPossibilidadeCobrancaPorProdutoController,
} from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import {
    AberturaEmMassaAudienciaController,
    InserirCasoDinamicamenteController,
    ValidaCasoRecorrenciaController,
} from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import { InserirDocumentoCasoController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { GetClientePorNomeOuEmailController } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarTipoDocumentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { ListarsSubCategoriasController } from "../../../../Controllers/Geral/SubCategoria/SubCategoriaController";

import { IContaProduto } from "../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import { CanalAtendimentoInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoCanalAtendimento/CanalAtendimentoInterfaces";
import { TipoDocumentoInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";
import { ISubCategoria } from "../../../../Interfaces/Geral/SubCategoria/SubCategoriaInterface";

import { AlertError } from "../../../../Tools/SweetAlerts";
import { IContatoCliente } from "../../../../Interfaces/Geral/Cliente/IClienteSimples";
import DOMPurify from "dompurify";
import { ACESSOS } from "../../../../Routes/Acessos";
import { IComponentModal } from "../../../Modais/IModalComponent";
import SeletorDeModulo from "./SeletorDeModulo";
import { useHistory } from "react-router-dom";
import SeletorCategoriaAtendimento from "../../Forms/SelectCategoriaAtendimento";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import { useUserInfor } from "../../../../Context/User";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SeletorPesoAtendimento from "./SeletorPesoAtendimento";
import { IDocumentoCreate } from "../../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import { InserirDocumentoDiretoEmCasoController } from "../../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { ListarComodosController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/Comodos/ComodosAssistencia";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Table from "../../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FroalaEditor } from "../../Forms/Editor/FroalaEditor";
import "./styles.css";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";

interface IFile extends File {
    ID_TIPO_DOCUMENTO?: number;
}
interface IFormData {
    ID_CONTA: number;
    ID_CATEGORIA_ATENDIMENTO: number;
    ID_CONTATO: number;
    ID_TIPO_CANAL_ATENDIMENTO: number;
    DS_CASO: string;
    ID_UNIDADE: number;
    ID_SUBCATEGORIA_ATENDIMENTO: number;
    ID_TIPO_DOCUMENTO: number;
    CONTA_SEARCH: string;
    ID_TIPO_PESO_ATENDIMENTO: number;
    ID_COMODO_ASSISTENCIA_TEC: [number];
    idComodos?: [number];
}
interface IProdutoBloqueioDeCobranca extends IContaProduto {
    FL_PODE_COBRAR?: boolean;
}
interface IClienteData {
    ID_CONTA: number;
    DS_CONTA: string;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
    ID_CONTATO?: number;
    uniqueID?: string;
    PRODUTOS?: Array<IProdutoBloqueioDeCobranca>;
    CONTATOS?: Array<IContatoCliente>;
}
interface IEmailData {
    DS_MENSAGEM: string;
    DS_REMETENTE: string;
    ID_EMAIL: number;
}
interface IAbrirAtendimentoProps {
    ID_MODULO: number;
    cliente?: IClienteData;
    email?: IEmailData;
    idEmpreendimento?: number;
    idUnidade?: number;
    canalAtendimento?: string;
    setShow: (show: boolean) => void;
    defaultDesc?: string;
    redirect?: "CANCEL" | "TARGET_BLANK";
    editCliente?: boolean;
    lockedDocs?: Array<Omit<IDocumentoCreate, "ID_CASO">>;
    emailCopia?: Array<{
        ID_REMETENTE: number;
        DS_REMETENTE: string;
    }>;
    ID_AUDIENCIA?: number;
}

const InfoTipoCaso = [
    {
        Link: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
        ID: ACESSOS.COBRANCA.ID_MODULO,
    },
    {
        Link: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
        ID: ACESSOS.ATENDIMENTO.ID_MODULO,
    },
    {
        Link: ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK,
        ID: ACESSOS.ASSISTENCIA.ID_MODULO,
    },
];

export function AbrirAtendimento(props: IAbrirAtendimentoProps) {
    const history = useHistory();
    const { Config } = useUserInfor();
    const { ID_MODULO, setShow } = props;
    const [descricaoHTML, setDescricaoHTML] = useState("");
    const [uploading, setUploading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const { id } = useModuloInfo();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const [cliente, setCliente] = useState(props.cliente);

    const [lstClientes, setLstClientes] = useState<Array<IClienteData>>();

    const [LstContatos, setLstContatos] = useState(props.cliente?.CONTATOS);
    const [LstCanalAtendimento, setLstCanalAtendimento] =
        useState<Array<CanalAtendimentoInterface>>();
    const [LstSubCategoria, setLstSubCategoria] =
        useState<Array<ISubCategoria>>();
    const [LsTipoDocumento, setLsTipoDocumento] =
        useState<Array<TipoDocumentoInterface>>();
    const [LstDocs, setLstDocs] = useState<Array<IFile>>();

    const jaCarregouPossibilidadeDeCobrarRef = useRef(false);

    const [idProduto, setIdProduto] = useState(
        props.idEmpreendimento ??
            props.cliente?.PRODUTOS?.[0]?.UNIDADE?.ID_UNIDADE
    );
    // const [dsCategoria, setDsCategoria] = useState<string | undefined>("");
    const [idCategoria, setIdCategoria] = useState<number | undefined>();
    // const [subIdCategoria, setSubIdCategoria] = useState<number | undefined>();

    const [criandoCaso, setCriandoCaso] = useState(false);

    const { value: listaComodos } = useAsyncEffect(() =>
        ListarComodosController()
    );

    const {
        execute: ValidaCasoRecorrencia,
        loading: ValidaCasoRecorrenciaLoading,
    } = useAsyncCallback(ValidaCasoRecorrenciaController);

    const {
        register,
        handleSubmit,
        reset,
        formState,
        setValue,
        getValues,
        control,
    } = useForm<IFormData>();

    useEffect(() => {
        if (idProduto && idCategoria) {
            ListarsSubCategoriasController(idProduto, idCategoria).then(
                (res) => {
                    setLstSubCategoria(res);
                }
            );
        }
    }, [idProduto, idCategoria]);

    useEffect(() => {
        if (!props.cliente && props.email) {
            GetClientePorNomeOuEmailController(props.email.DS_REMETENTE).then(
                (res) => {
                    if (res.length === 1) {
                        setCliente({
                            DS_CONTA: res[0].DS_NOME_CONTA || "",
                            ID_CONTA: res[0].ID_CONTA || 0,
                        });
                        setLstContatos(res[0].CONTATOS);
                    } else {
                        setLstClientes(
                            res.map((cliente) => ({
                                DS_CONTA: cliente.DS_NOME_CONTA || "",
                                ID_CONTA: cliente.ID_CONTA || 0,
                            }))
                        );
                    }
                }
            );
        }
    }, [props.cliente, props.email]);

    useEffect(() => {
        if (cliente?.ID_CONTA && !cliente.PRODUTOS) {
            ListarProdutosPorContaCompleto(cliente.ID_CONTA, ID_MODULO).then(
                (res) => {
                    setCliente((c) =>
                        c
                            ? {
                                  ...c,
                                  PRODUTOS: res,
                              }
                            : undefined
                    );
                    setIdProduto((p) => p ?? res[0]?.UNIDADE?.ID_UNIDADE);
                }
            );
        }

        if (cliente?.CONTATOS && cliente.CONTATOS.length > 0) {
            setLstContatos(cliente?.CONTATOS);
        } else if (cliente?.ID_CONTA) {
            ListarContatosController(cliente.ID_CONTA).then((res) => {
                setLstContatos(
                    res.map((contato) => ({
                        DS_NOME_CONTATO: contato.DS_NOME || "",
                        ID_CONTATO: contato.ID_CONTATO,
                        ID_CONTA_CONTATO: 0,
                        DS_TIPO_RELACAO_CLIENTE:
                            contato.DS_TIPO_RELACAO_CLIENTE,
                    }))
                );
                if (res.length === 1) setValue("ID_CONTATO", res[0].ID_CONTATO);
            });
        }
    }, [
        cliente?.ID_CONTA,
        cliente?.CONTATOS,
        cliente?.PRODUTOS,
        props.idUnidade,
        setValue,
        ID_MODULO,
    ]);

    useEffect(() => {
        if (
            Config.ConfigCobrancaDTO.FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA &&
            cliente?.PRODUTOS &&
            ID_MODULO === ACESSOS.COBRANCA.ID_MODULO &&
            !jaCarregouPossibilidadeDeCobrarRef.current
        ) {
            VerificarPossibilidadeCobrancaPorProdutoController(
                cliente.PRODUTOS.map((p) => p.UNIDADE?.ID_UNIDADE)
            ).then((lstPodeCobrar) => {
                jaCarregouPossibilidadeDeCobrarRef.current = true;
                setCliente((c) =>
                    c
                        ? {
                              ...c,
                              PRODUTOS:
                                  cliente.PRODUTOS?.map((produto, i) => ({
                                      ...produto,
                                      FL_PODE_COBRAR: lstPodeCobrar[i],
                                  })) ?? [],
                          }
                        : undefined
                );
                // setta o idProduto selecionado como o primeiro que pode ser cobrando
                setIdProduto((p) => {
                    const pIndex = cliente?.PRODUTOS?.findIndex(
                        (prod) => prod.UNIDADE.ID_UNIDADE === p
                    );
                    if (pIndex !== undefined && pIndex >= 0) {
                        const podeCobrar = lstPodeCobrar[pIndex];
                        if (!podeCobrar) {
                            const indexPrimeiroPodeCobrar =
                                lstPodeCobrar.findIndex(Boolean);
                            if (
                                indexPrimeiroPodeCobrar >= 0 &&
                                cliente.PRODUTOS
                            )
                                return cliente.PRODUTOS[indexPrimeiroPodeCobrar]
                                    .UNIDADE.ID_UNIDADE;
                        }
                    }
                    return p;
                });
            });
        }
    }, [
        Config.ConfigCobrancaDTO.FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA,
        cliente?.PRODUTOS,
        ID_MODULO,
    ]);

    const produtosFiltrados = cliente?.PRODUTOS?.filter((produto) => {
        const showInput =
            (produto.UNIDADE.FL_STATUS_VENDA &&
                !Config.FL_ABRIR_CASO_VENDA_CANCELADA) ||
            (Config.FL_ABRIR_CASO_VENDA_CANCELADA &&
                (produto.UNIDADE.FL_STATUS_VENDA ||
                    !produto.UNIDADE.FL_STATUS_VENDA));
        return showInput;
    });

    useEffect(() => {
        ListarCanalAtendimentoContoller().then((res) => {
            setLstCanalAtendimento(res);
        });
        ListarTipoDocumentoController().then((res) => {
            setLsTipoDocumento(res);
        });
    }, [ID_MODULO, setValue]);

    useEffect(() => {
        if (cliente?.ID_CONTATO) setValue("ID_CONTATO", cliente?.ID_CONTATO);
    }, [LstContatos, cliente?.ID_CONTATO, setValue]);

    function handleInserirCasoFormSubmit(formData: IFormData) {
        // Mapeia o html e substitui o src pelo link que é armazenado no state uploadedImages de forma dinamica
        let modifiedHistoricoHTML = descricaoHTML;
        const imagesToReplace =
            modifiedHistoricoHTML.match(/<img[^>]*src="blob[^"]*"[^>]*>/g) ||
            [];

        imagesToReplace.forEach((imageTag) => {
            const uploadedImageUrl = uploadedImages.shift() || "";
            modifiedHistoricoHTML = modifiedHistoricoHTML.replace(
                /<img[^>]*src="blob[^"]*"[^>]*>/,
                imageTag.replace(/src="blob[^"]*"/, `src="${uploadedImageUrl}"`)
            );
        });

        const FormData = {
            ID_CATEGORIA_ATENDIMENTO: idCategoria,
            ID_CONTATO: formData.ID_CONTATO,
            ID_TIPO_CANAL_ATENDIMENTO: formData.ID_TIPO_CANAL_ATENDIMENTO,
            DS_CASO: props.email
                ? DOMPurify.sanitize(props.email?.DS_MENSAGEM)
                : modifiedHistoricoHTML,
            ID_PRODUTO: formData.ID_UNIDADE || 1,
            ID_SUBCATEGORIA_ATENDIMENTO: formData.ID_SUBCATEGORIA_ATENDIMENTO
                ? formData.ID_SUBCATEGORIA_ATENDIMENTO
                : null,
            ID_TIPO_CASO: ID_MODULO,
            ID_CONTA: cliente?.ID_CONTA || formData.ID_CONTA || 1,
            ID_TIPO_RECORRENCIA: null,
            IDEmail: props.email?.ID_EMAIL,
            ID_TIPO_PESO_ATENDIMENTO: formData.ID_TIPO_PESO_ATENDIMENTO,
            ID_COMODOS: formData.ID_COMODO_ASSISTENCIA_TEC,
        };

        setCriandoCaso(true);
        if (
            (ACESSOS.ASSISTENCIA.ID_MODULO === id ||
                ACESSOS.ASSISTENCIA.ID_MODULO === ID_MODULO) &&
            emccampMode
        ) {
            ValidaCasoRecorrencia(FormData).then((res) => {
                if (!res.Data) {
                    InserirCasoDinamicamenteController(
                        FormData,
                        props.cliente?.uniqueID ?? ""
                    )
                        .then(async (res) => {
                            props.lockedDocs?.map(async (doc) => {
                                await InserirDocumentoDiretoEmCasoController({
                                    ...doc,
                                    ID_CASO: res.IDResponse,
                                });
                            });
                            LstDocs &&
                                LstDocs.map(async (doc) => {
                                    if (doc.ID_TIPO_DOCUMENTO) {
                                        await InserirDocumentoCasoController({
                                            DS_DOCUMENTO: doc.name,
                                            ID_CASO: res.IDResponse,
                                            ID_TIPO_DOCUMENTO:
                                                doc.ID_TIPO_DOCUMENTO,
                                            File: doc,
                                        });
                                    } else
                                        AlertError(
                                            "Favor Inserir um Tipo Documento",
                                            ""
                                        );
                                });

                            setShow(false);
                            reset();
                            return res;
                        })
                        .then((res) => {
                            const link = InfoTipoCaso.find(
                                (m) => m.ID === props.ID_MODULO
                            )?.Link;
                            if (props.redirect !== "CANCEL" && link) {
                                if (props.redirect === "TARGET_BLANK")
                                    window.open(link(res.IDResponse), "_blank");
                                else history.push(link(res.IDResponse));
                            }
                        })
                        .finally(() => setCriandoCaso(false));
                    return;
                }

                Swal.fire({
                    title: "Deseja abrir um atendimento recorrente?",
                    icon: "info",
                    buttonsStyling: false,
                    confirmButtonText: "<i class='la la-check'></i> Sim!",
                    showCancelButton: true,
                    cancelButtonText: "<i class='la la-thumbs-down'></i> Não",
                    customClass: {
                        confirmButton: "btn btn-outline-success",
                        cancelButton: "btn btn-default",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        InserirCasoDinamicamenteController(
                            FormData,
                            props.cliente?.uniqueID ?? ""
                        )
                            .then(async (res) => {
                                props.lockedDocs?.map(async (doc) => {
                                    await InserirDocumentoDiretoEmCasoController(
                                        {
                                            ...doc,
                                            ID_CASO: res.IDResponse,
                                        }
                                    );
                                });
                                LstDocs &&
                                    LstDocs.map(async (doc) => {
                                        if (doc.ID_TIPO_DOCUMENTO) {
                                            await InserirDocumentoCasoController(
                                                {
                                                    DS_DOCUMENTO: doc.name,
                                                    ID_CASO: res.IDResponse,
                                                    ID_TIPO_DOCUMENTO:
                                                        doc.ID_TIPO_DOCUMENTO,
                                                    File: doc,
                                                }
                                            );
                                        } else
                                            AlertError(
                                                "Favor Inserir um Tipo Documento",
                                                ""
                                            );
                                    });

                                setShow(false);
                                reset();
                                return res;
                            })
                            .then((res) => {
                                const link = InfoTipoCaso.find(
                                    (m) => m.ID === props.ID_MODULO
                                )?.Link;
                                if (props.redirect !== "CANCEL" && link) {
                                    if (props.redirect === "TARGET_BLANK")
                                        window.open(
                                            link(res.IDResponse),
                                            "_blank"
                                        );
                                    else history.push(link(res.IDResponse));
                                }
                            })
                            .finally(() => setCriandoCaso(false));
                    }
                });
            });
        } else if (ACESSOS.AUTOMACAO.ID_MODULO === id && props.ID_AUDIENCIA) {
            AberturaEmMassaAudienciaController(FormData, props.ID_AUDIENCIA)
                .then(async (res) => {
                    props.lockedDocs?.map(async (doc) => {
                        await InserirDocumentoDiretoEmCasoController({
                            ...doc,
                            ID_CASO: res.IDResponse,
                        });
                    });
                    LstDocs &&
                        LstDocs.map(async (doc) => {
                            if (doc.ID_TIPO_DOCUMENTO) {
                                await InserirDocumentoCasoController({
                                    DS_DOCUMENTO: doc.name,
                                    ID_CASO: res.IDResponse,
                                    ID_TIPO_DOCUMENTO: doc.ID_TIPO_DOCUMENTO,
                                    File: doc,
                                });
                            } else
                                AlertError(
                                    "Favor Inserir um Tipo Documento",
                                    ""
                                );
                        });

                    setShow(false);
                    reset();
                    return res;
                })
                .finally(() => setCriandoCaso(false));
        } else {
            InserirCasoDinamicamenteController(
                FormData,
                props.cliente?.uniqueID ?? ""
            )
                .then(async (res) => {
                    props.lockedDocs?.map(async (doc) => {
                        await InserirDocumentoDiretoEmCasoController({
                            ...doc,
                            ID_CASO: res.IDResponse,
                        });
                    });
                    LstDocs &&
                        LstDocs.map(async (doc) => {
                            if (doc.ID_TIPO_DOCUMENTO) {
                                await InserirDocumentoCasoController({
                                    DS_DOCUMENTO: doc.name,
                                    ID_CASO: res.IDResponse,
                                    ID_TIPO_DOCUMENTO: doc.ID_TIPO_DOCUMENTO,
                                    File: doc,
                                });
                            } else
                                AlertError(
                                    "Favor Inserir um Tipo Documento",
                                    ""
                                );
                        });

                    setShow(false);
                    reset();
                    return res;
                })
                .then((res) => {
                    const link = InfoTipoCaso.find(
                        (m) => m.ID === props.ID_MODULO
                    )?.Link;
                    if (props.redirect !== "CANCEL" && link) {
                        if (props.redirect === "TARGET_BLANK")
                            window.open(link(res.IDResponse), "_blank");
                        else history.push(link(res.IDResponse));
                    }
                })
                .finally(() => setCriandoCaso(false));
        }
    }

    const columnsCopiaEmail: Array<ColumnDescription> = [
        {
            dataField: "DS_REMETENTE",
            text: "Emails Cópia (CC)",
            classes: "p-3 ws-nowrap",
        },
    ];

    return (
        <div>
            <form
                onSubmit={handleSubmit(handleInserirCasoFormSubmit)}
                className="w-100 align-itens-center mt-5"
            >
                <div className="mb-5">
                    <div className="row">
                        {ACESSOS.AUTOMACAO.ID_MODULO !== id && (
                            <>
                                {cliente ? (
                                    <>
                                        <div className="col-12 col-lg-6 pl-5 d-flex justify-content-between align-items-center">
                                            <h4>
                                                {" "}
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                    size="lg"
                                                    className="mr-3"
                                                />
                                                {cliente.DS_CONTA}
                                            </h4>
                                        </div>
                                        {props.editCliente && (
                                            <div className="col-12 col-lg-6 d-flex justify-content-end">
                                                <button
                                                    className="btn btn-outline-danger font-weight-bold d-flex align-items-center ml-2 mr-2 g-2"
                                                    type="button"
                                                    onClick={() => {
                                                        setCliente(undefined);
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faUserSlash}
                                                        size="lg"
                                                    />{" "}
                                                    Remover Cliente
                                                </button>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-1">
                                                <input
                                                    name="CONTA_SEARCH"
                                                    className={`form-control placeholder-dark-50`}
                                                    defaultValue={
                                                        props.email
                                                            ?.DS_REMETENTE
                                                    }
                                                    ref={register()}
                                                />
                                                <button
                                                    className="btn btn-primary ml-2"
                                                    type="button"
                                                    onClick={() => {
                                                        const search =
                                                            getValues(
                                                                "CONTA_SEARCH"
                                                            );
                                                        GetClientePorNomeOuEmailController(
                                                            search
                                                        ).then((res) => {
                                                            if (
                                                                res.length > 0
                                                            ) {
                                                                setLstClientes(
                                                                    res.map(
                                                                        (
                                                                            cliente
                                                                        ) => ({
                                                                            DS_CONTA:
                                                                                cliente.DS_NOME_CONTA ||
                                                                                "",
                                                                            ID_CONTA:
                                                                                cliente.ID_CONTA ||
                                                                                0,
                                                                        })
                                                                    )
                                                                );
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                    />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <FontAwesomeIcon
                                                            icon={faUser}
                                                            size="lg"
                                                        />
                                                    </span>
                                                </div>
                                                <select
                                                    name="ID_CONTA"
                                                    className={`form-control placeholder-dark-50 ${
                                                        formState.errors
                                                            .ID_CONTA &&
                                                        "is-invalid"
                                                    }`}
                                                    ref={register({
                                                        required:
                                                            "Insira o Cliente",
                                                        valueAsNumber: true,
                                                        min: {
                                                            value: 1,
                                                            message:
                                                                "Favor selecione uma opção",
                                                        },
                                                    })}
                                                    onChange={(e) => {
                                                        const conta_id =
                                                            Number.parseInt(
                                                                e.target.value
                                                            );
                                                        if (conta_id) {
                                                            const conta =
                                                                lstClientes?.find(
                                                                    (c) =>
                                                                        c.ID_CONTA ===
                                                                        conta_id
                                                                );
                                                            if (conta)
                                                                setCliente({
                                                                    DS_CONTA:
                                                                        conta?.DS_CONTA,
                                                                    ID_CONTA:
                                                                        conta?.ID_CONTA,
                                                                });
                                                            ListarContatosController(
                                                                conta_id
                                                            ).then((res) => {
                                                                setLstContatos(
                                                                    res.map(
                                                                        (
                                                                            contato
                                                                        ) => ({
                                                                            DS_NOME_CONTATO:
                                                                                contato.DS_NOME ||
                                                                                "",
                                                                            ID_CONTATO:
                                                                                contato.ID_CONTATO,
                                                                            ID_CONTA_CONTATO: 0,
                                                                        })
                                                                    )
                                                                );
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <option value={0}>
                                                        Selecione um cliente
                                                    </option>
                                                    {lstClientes?.length ? (
                                                        lstClientes.map(
                                                            (cliente) => {
                                                                return (
                                                                    <option
                                                                        key={
                                                                            cliente.ID_CONTA
                                                                        }
                                                                        value={
                                                                            cliente.ID_CONTA
                                                                        }
                                                                    >
                                                                        {
                                                                            cliente.DS_CONTA
                                                                        }
                                                                    </option>
                                                                );
                                                            }
                                                        )
                                                    ) : (
                                                        <option></option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-5">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <FontAwesomeIcon
                                        icon={faAlignJustify}
                                        size="lg"
                                    />
                                </span>
                            </div>
                            {/* <select
                                name="ID_CATEGORIA_ATENDIMENTO"
                                className = {`form-control placeholder-dark-50 ${formState.errors.ID_CATEGORIA_ATENDIMENTO && 'is-invalid'}`}
                                ref={register({
                                    required: "Insira a Categoria Ateendimento",
                                    valueAsNumber:true,
                                    min:{
                                        value: 1,
                                        message: "Favor selecione uma opção"
                                    }
                                })}
                                onChange={e => {
                                    Number.parseInt(e.target.value)
                                    setIdCategoria(Number.parseInt(e.target.value))
                                }}
                            >
                                <option value={0}>Selecione uma categoria de atendimento</option>
                                {
                                    LstCategoria?.map(c=>(
                                        <option value={c.ID_CATEGORIA_ATENDIMENTO}>{c.DS_CATEGORIA_ATENDIMENTO}</option>
                                    )) 
                                }
                            </select> */}
                            <SeletorCategoriaAtendimento
                                showPlaceholder
                                ID_MODULO={props.ID_MODULO}
                                setIdCategoria={(c) =>
                                    setIdCategoria(c as number)
                                }
                                filterTreeNode={(input, treeNode) =>
                                    treeNode?.props.title
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                showSearch
                                control={control}
                            />
                        </div>

                        {ACESSOS.COBRANCA.ID_MODULO !== id &&
                            ACESSOS.AUTOMACAO.ID_MODULO !== id && (
                                <div className="input-group mb-5">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <FontAwesomeIcon
                                                icon={faAlignLeft}
                                                size="lg"
                                            />
                                        </span>
                                    </div>
                                    {/*tem alguma coisa que pode ser feita, tipo para eu enviar o Id sub categoria? kkakaa */}

                                    <select
                                        name="ID_SUBCATEGORIA_ATENDIMENTO"
                                        className={`form-control placeholder-dark-50`}
                                        ref={register({
                                            valueAsNumber: true,
                                        })}
                                        disabled={
                                            idProduto == null ||
                                            idCategoria == null
                                        }
                                    >
                                        <option value={0}>
                                            Selecione uma subcategoria
                                        </option>
                                        {LstSubCategoria?.length ? (
                                            LstSubCategoria.map(
                                                (subCategoria) => {
                                                    return (
                                                        <option
                                                            key={
                                                                subCategoria.ID_SUB_CATEGORIA_ATENDIMENTO
                                                            }
                                                            value={
                                                                subCategoria.ID_SUB_CATEGORIA_ATENDIMENTO
                                                            }
                                                        >
                                                            {
                                                                subCategoria.DS_SUBCATEGORIA_ATENDIMENTO
                                                            }
                                                        </option>
                                                    );
                                                }
                                            )
                                        ) : (
                                            <option>
                                                Não contém subcategoria
                                            </option>
                                        )}
                                    </select>
                                </div>
                            )}

                        {ACESSOS.AUTOMACAO.ID_MODULO !== id && (
                            <div className="input-group mb-5">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <FontAwesomeIcon
                                            icon={faComment}
                                            size="lg"
                                        />
                                    </span>
                                </div>
                                {LstContatos && (
                                    <select
                                        name="ID_CONTATO"
                                        className={`form-control placeholder-dark-50 ${
                                            formState.errors.ID_CONTATO &&
                                            "is-invalid"
                                        }`}
                                        defaultValue={
                                            cliente?.ID_CONTATO ||
                                            props.cliente?.ID_CONTA
                                                ? LstContatos?.find(
                                                      (contato) =>
                                                          contato.DS_TIPO_RELACAO_CLIENTE ===
                                                          "Proprietário"
                                                  )?.ID_CONTATO
                                                : 0
                                        }
                                        ref={register({
                                            required: "Insira um contato",
                                            valueAsNumber: true,
                                            min: {
                                                value: 1,
                                                message:
                                                    "Favor selecione uma opção",
                                            },
                                        })}
                                    >
                                        <option value={0}>
                                            Selecione um contato
                                        </option>
                                        {LstContatos.map((contatos) => {
                                            return (
                                                <option
                                                    key={contatos.ID_CONTATO}
                                                    value={contatos.ID_CONTATO}
                                                >
                                                    {contatos.DS_NOME_CONTATO}
                                                </option>
                                            );
                                        })}
                                    </select>
                                )}
                            </div>
                        )}

                        <div className="input-group mb-5">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <FontAwesomeIcon
                                        icon={faAddressCard}
                                        size="lg"
                                    />
                                </span>
                            </div>

                            {LstCanalAtendimento && (
                                <select
                                    className={`form-control placeholder-dark-50 ${
                                        formState.errors
                                            .ID_TIPO_CANAL_ATENDIMENTO &&
                                        "is-invalid"
                                    }`}
                                    defaultValue={
                                        (props.email
                                            ? LstCanalAtendimento?.find(
                                                  (canal) =>
                                                      canal.DS_TIPO_CANAL_ATENDIMENTO ===
                                                      "Email"
                                              )?.ID_TIPO_CANAL_ATENDIMENTO
                                            : props.canalAtendimento &&
                                              LstCanalAtendimento?.find(
                                                  (canal) =>
                                                      canal.DS_TIPO_CANAL_ATENDIMENTO ===
                                                      props.canalAtendimento
                                              )?.ID_TIPO_CANAL_ATENDIMENTO) ||
                                        props.cliente?.ID_TIPO_CANAL_ATENDIMENTO
                                    }
                                    name="ID_TIPO_CANAL_ATENDIMENTO"
                                    ref={register({
                                        valueAsNumber: true,
                                        required:
                                            "Insira o canal de atendimento",
                                        min: {
                                            value: 1,
                                            message:
                                                "Favor selecione uma opção",
                                        },
                                    })}
                                >
                                    <option value={0}>
                                        Selecione um tipo canal atendimento
                                    </option>
                                    {LstCanalAtendimento?.length ? (
                                        LstCanalAtendimento.map((canal) => {
                                            return (
                                                <option
                                                    key={
                                                        canal.ID_TIPO_CANAL_ATENDIMENTO
                                                    }
                                                    value={
                                                        canal.ID_TIPO_CANAL_ATENDIMENTO
                                                    }
                                                >
                                                    {
                                                        canal.DS_TIPO_CANAL_ATENDIMENTO
                                                    }
                                                </option>
                                            );
                                        })
                                    ) : (
                                        <option></option>
                                    )}
                                </select>
                            )}
                        </div>

                        {props.ID_MODULO !== ACESSOS.COBRANCA.ID_MODULO && (
                            <SeletorPesoAtendimento
                                name="ID_TIPO_PESO_ATENDIMENTO"
                                ref={register({
                                    valueAsNumber: true,
                                })}
                            />
                        )}

                        {ACESSOS.ASSISTENCIA.ID_MODULO === ID_MODULO &&
                            emccampMode === ID_ORGANIZACAO && (
                                <div className="input-group mb-5">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <FontAwesomeIcon
                                                icon={faBed}
                                                size="lg"
                                            />
                                        </span>
                                    </div>
                                    <select
                                        placeholder="Cômodos"
                                        defaultValue={[]}
                                        name="ID_COMODO_ASSISTENCIA_TEC"
                                        className={`form-control placeholder-dark-50 ${
                                            formState.errors
                                                .ID_TIPO_CANAL_ATENDIMENTO &&
                                            "is-invalid"
                                        }`}
                                        ref={register({
                                            valueAsNumber: true,
                                            required:
                                                "Insira o Comodo para assistência",
                                            min: {
                                                value: 1,
                                                message:
                                                    "Favor selecione uma opção",
                                            },
                                        })}
                                    >
                                        <option></option>
                                        {listaComodos?.map((comodo) => (
                                            <option
                                                value={
                                                    comodo.ID_COMODO_ASSISTENCIA_TEC
                                                }
                                            >
                                                {comodo.DS_COMODO}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                        <div>
                            <div className="pl-4 d-flex d-flex-wrap justify-content-between align-items-center">
                                <h6>Produtos:</h6>
                            </div>

                            <div className="d-flex flex-wrap justify-content-between gap-3">
                                {produtosFiltrados &&
                                produtosFiltrados.length > 0 ? (
                                    produtosFiltrados.map((produto, index) => {
                                        const checked =
                                            (Config.FL_ABRIR_CASO_VENDA_CANCELADA &&
                                                produto.UNIDADE
                                                    .FL_STATUS_VENDA &&
                                                index === 0) ||
                                            produtosFiltrados.length === 1;

                                        return (
                                            <div
                                                key={produto.UNIDADE.ID_UNIDADE}
                                                className="col-12 col-md-6 d-flex align-items-stretch p-2"
                                            >
                                                <div className="card w-100 shadow-sm d-flex flex-column">
                                                    <label
                                                        className={`option ${
                                                            checked
                                                                ? "active"
                                                                : ""
                                                        } w-100 p-3 h-100 d-flex justify-content-between mb-0`}
                                                    >
                                                        <span className="option-control mb-2">
                                                            <span className="radio">
                                                                <input
                                                                    type="radio"
                                                                    name="ID_UNIDADE"
                                                                    value={
                                                                        produto
                                                                            .UNIDADE
                                                                            .ID_UNIDADE
                                                                    }
                                                                    checked={
                                                                        checked ||
                                                                        (idProduto ===
                                                                            produto
                                                                                .UNIDADE
                                                                                .ID_UNIDADE &&
                                                                            produto.FL_PODE_COBRAR !==
                                                                                false &&
                                                                            (produto
                                                                                .UNIDADE
                                                                                .FL_STATUS_VENDA ||
                                                                                (!produto
                                                                                    .UNIDADE
                                                                                    .FL_STATUS_VENDA &&
                                                                                    Config.FL_ABRIR_CASO_VENDA_CANCELADA)))
                                                                    }
                                                                    ref={register(
                                                                        {
                                                                            valueAsNumber:
                                                                                true,
                                                                            required:
                                                                                "Insira uma unidade",
                                                                        }
                                                                    )}
                                                                    disabled={
                                                                        produto.FL_PODE_COBRAR ===
                                                                            false ||
                                                                        (!produto
                                                                            .UNIDADE
                                                                            .FL_STATUS_VENDA &&
                                                                            !Config.FL_ABRIR_CASO_VENDA_CANCELADA)
                                                                    }
                                                                    onChange={() =>
                                                                        setIdProduto(
                                                                            produto
                                                                                .UNIDADE
                                                                                .ID_UNIDADE
                                                                        )
                                                                    }
                                                                />
                                                                <span></span>
                                                            </span>
                                                        </span>

                                                        <span className="option-label">
                                                            <span className="option-head mb-2 d-flex align-items-center justify-content-between">
                                                                <span className="option-title">
                                                                    {
                                                                        produto.DS_EMPREENDIMENTO
                                                                    }
                                                                </span>
                                                                {produto.FL_PODE_COBRAR ===
                                                                    false && (
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip
                                                                                id={`FL_N_COBRAR_${produto.ID_EMPREENDIMENTO}`}
                                                                            >
                                                                                Esse
                                                                                produto
                                                                                não
                                                                                pode
                                                                                ser
                                                                                cobrado
                                                                                pois
                                                                                possui
                                                                                promessa
                                                                                de
                                                                                pagamento
                                                                                em
                                                                                andamento
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faInfoCircle
                                                                            }
                                                                            className="text-warning ms-2"
                                                                        />
                                                                    </OverlayTrigger>
                                                                )}
                                                            </span>
                                                            {produto.UNIDADE
                                                                .FL_STATUS_VENDA ? (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip
                                                                            id={``}
                                                                        >
                                                                            Unidade
                                                                            ativa
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="text-success">
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faCheck
                                                                            }
                                                                        />{" "}
                                                                    </span>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip
                                                                            id={``}
                                                                        >
                                                                            Unidade
                                                                            desativada
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="text-danger">
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faTimes
                                                                            }
                                                                        />
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}

                                                            <span className="option-body text-secondary mt-2">
                                                                {
                                                                    produto
                                                                        .UNIDADE
                                                                        .DS_UNIDADE
                                                                }
                                                            </span>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <span className="text-center w-100">
                                        Não contém nenhum produto
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center col-12 col-lg-6">
                        {props.email ? (
                            <div
                                className="custom-scroll h-100 border p-1"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        props.email?.DS_MENSAGEM
                                    ),
                                }}
                            />
                        ) : (
                            <div className="col-12">
                                {uploading && (
                                    <div className="d-flex justify-content-center align-items-center">
                                        <span>Fazendo upload de imagem</span>
                                        <Spinner size="sm" color="primary" />
                                    </div>
                                )}
                                <FroalaEditor
                                    onChange={(value) =>
                                        setDescricaoHTML(value)
                                    }
                                    value={descricaoHTML}
                                    onImageUploadStart={() =>
                                        setUploading(true)
                                    }
                                    defaultValue={props.defaultDesc ?? ""}
                                    onImageUploadEnd={() => setUploading(false)}
                                    setUploadedImages={setUploadedImages}
                                />
                                <div className="mt-4">
                                    <div className="pl-3 d-flex justify-content-between align-items-center">
                                        <h6>Documentos:</h6>
                                        <label htmlFor="file_input">
                                            <span className="btn btn-clean btn-icon btn-md ml-2 mr-2">
                                                <FontAwesomeIcon
                                                    icon={faPaperclip}
                                                    size="lg"
                                                />
                                            </span>
                                        </label>
                                    </div>

                                    <div>
                                        <input
                                            type="file"
                                            multiple
                                            id="file_input"
                                            className="d-none"
                                            onChange={(e) => {
                                                const docs: Array<IFile> =
                                                    Array.from(LstDocs || []);

                                                for (
                                                    let index = 0;
                                                    index <
                                                    (e.target.files?.length ||
                                                        0);
                                                    index++
                                                ) {
                                                    const element =
                                                        e.target.files?.item(
                                                            index
                                                        );
                                                    if (element)
                                                        docs.push(element);
                                                }
                                                setLstDocs(docs);
                                            }}
                                        />

                                        {LstDocs && LstDocs.length > 0 ? (
                                            LstDocs.map(
                                                (arquivo: IFile, index) => {
                                                    return (
                                                        <div
                                                            className="d-flex flex-wrap justify-content-between"
                                                            key={index}
                                                        >
                                                            <div
                                                                className="btn btn-clean col-12 col-lg-6 d-flex justify-content-between mb-1"
                                                                onClick={() => {
                                                                    setLstDocs(
                                                                        LstDocs.filter(
                                                                            (
                                                                                doc
                                                                            ) =>
                                                                                doc.name !==
                                                                                arquivo.name
                                                                        )
                                                                    );
                                                                }}
                                                            >
                                                                {arquivo.name
                                                                    .length > 20
                                                                    ? arquivo.name.substr(
                                                                          0,
                                                                          20
                                                                      ) + "..."
                                                                    : arquivo.name}
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faTimes
                                                                    }
                                                                    className="text-danger ml-2"
                                                                />
                                                            </div>

                                                            <div className="col-12 col-lg-6">
                                                                <select
                                                                    name="ID_TIPO_DOCUMENTO"
                                                                    className={`form-control placeholder-dark-50 ${
                                                                        formState
                                                                            .errors
                                                                            .ID_TIPO_DOCUMENTO &&
                                                                        "is-invalid"
                                                                    }`}
                                                                    ref={register(
                                                                        {
                                                                            required:
                                                                                "Insira a tipo documento",
                                                                            valueAsNumber:
                                                                                true,
                                                                            min: {
                                                                                value: 1,
                                                                                message:
                                                                                    "Favor selecione uma opção",
                                                                            },
                                                                        }
                                                                    )}
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const docs =
                                                                            Array.from(
                                                                                LstDocs ||
                                                                                    []
                                                                            );
                                                                        docs[
                                                                            index
                                                                        ].ID_TIPO_DOCUMENTO =
                                                                            Number.parseInt(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );

                                                                        setLstDocs(
                                                                            docs
                                                                        );
                                                                    }}
                                                                >
                                                                    <option
                                                                        value={
                                                                            0
                                                                        }
                                                                    >
                                                                        Selecione
                                                                        tipo
                                                                        documento
                                                                    </option>
                                                                    {LsTipoDocumento?.length ? (
                                                                        LsTipoDocumento.map(
                                                                            (
                                                                                TipoDoc
                                                                            ) => {
                                                                                return (
                                                                                    <option
                                                                                        key={
                                                                                            TipoDoc.ID_TIPO_DOCUMENTO
                                                                                        }
                                                                                        value={
                                                                                            TipoDoc.ID_TIPO_DOCUMENTO
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            TipoDoc.DS_TIPO_DOCUMENTO
                                                                                        }
                                                                                    </option>
                                                                                );
                                                                            }
                                                                        )
                                                                    ) : (
                                                                        <option></option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )
                                        ) : (
                                            <div></div>
                                        )}
                                        {props.lockedDocs && (
                                            <div className="d-flex flex-wrap align-items-center w-100">
                                                {props.lockedDocs.map(
                                                    (doc, index) => (
                                                        <button
                                                            key={index}
                                                            disabled
                                                            className="btn btn-clean d-flex justify-content-between align-items-center g-2 mb-1 text-truncate"
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <span className="text-truncate">
                                                                {
                                                                    doc.DS_DOCUMENTO
                                                                }
                                                            </span>
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faPaperclip
                                                                }
                                                            />
                                                        </button>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {props.emailCopia && (
                    <div className="py-2 w-50">
                        <Table
                            columns={columnsCopiaEmail}
                            data={props.emailCopia ?? []}
                            keyField="ID_REMETENTE"
                            noSearch
                        />
                    </div>
                )}

                <div className="d-flex justify-content-end mt-2">
                    <button
                        className="btn btn-outline-primary font-weight-bold d-flex align-items-center ml-3 mr-3 g-2"
                        disabled={
                            criandoCaso ||
                            uploading ||
                            ValidaCasoRecorrenciaLoading
                        }
                    >
                        {criandoCaso || ValidaCasoRecorrenciaLoading ? (
                            <Spinner color="primary" size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faPlus} size="lg" />
                        )}
                        Abrir atendimento
                    </button>
                </div>
            </form>
        </div>
    );
}

export function AbrirAtendimentoSelecionandoTipoCaso(
    setShow: (show: boolean) => void,
    setModal: (modal: IComponentModal) => void,
    props: IAbrirAtendimentoProps
) {
    if (props.ID_MODULO) {
        setModal({
            size: "xl",
            headerComponent: "Abrir Atendimento",
            IconHeader: faAngleRight,
            Component: () => <AbrirAtendimento {...props} />,
        });
    } else {
        setModal({
            headerComponent: "Abrir Atendimento",
            noFooter: true,
            IconHeader: faAngleRight,
            Component: () => (
                <SeletorDeModulo
                    setShow={setShow}
                    then={(modulo) => {
                        setTimeout(() => {
                            setModal({
                                size: "xl",
                                headerComponent: modulo.DS_MODULO,
                                IconHeader: faAngleRight,
                                Component: () => (
                                    <AbrirAtendimento
                                        {...props}
                                        ID_MODULO={modulo.ID_MODULO}
                                    />
                                ),
                            });
                            setShow(true);
                        }, 300);
                    }}
                />
            ),
        });
    }

    setShow(true);
}
